import { ChartOptions, CoreScaleOptions, Scale, Tick } from 'chart.js';

/**
 * O Chart.js corta o rótulo longo pela esquerda, comendo o começo do texto: um tipo de comissão
 * virava "erno com representação do CFM". Este callback corta pelo fim, preservando o início,
 * que é a parte que identifica o item.
 *
 * O limite é derivado da largura real da escala, porque o mesmo gráfico aparece em cards de
 * larguras diferentes (meia coluna, coluna inteira e dentro do diálogo de maximizar).
 */
export function truncarRotuloCategoria(limiteMaximo = 34) {
    return function (this: Scale<CoreScaleOptions>, valor: string | number, _indice: number, _ticks: Tick[]): string {
        const rotulo = this.getLabelForValue(Number(valor)) ?? '';

        const fonte = (this.options as { ticks?: { font?: { size?: number } } })?.ticks?.font?.size ?? 11;
        // ~0,55 do tamanho da fonte por caractere é uma aproximação estável para as fontes do tema.
        const larguraPorCaractere = fonte * 0.55;
        const espacoDisponivel = Math.max((this.width ?? 0) - 8, 0);
        const cabeNoEixo = espacoDisponivel > 0 ? Math.floor(espacoDisponivel / larguraPorCaractere) : limiteMaximo;

        const limite = Math.max(8, Math.min(limiteMaximo, cabeNoEixo));
        return rotulo.length > limite ? `${rotulo.slice(0, limite - 1)}…` : rotulo;
    };
}

/** Tooltip precisa mostrar o rótulo inteiro, já que o eixo pode estar truncado. */
export const tituloTooltipCompleto = (itens: { label?: string }[]): string => itens?.[0]?.label ?? '';

export type OpcoesGraficoBarra = ChartOptions<'bar'>;
